import { FormatIndentDecrease, FormatIndentIncrease } from '@mui/icons-material';
import { MenuButton, useRichTextEditorContext } from 'mui-tiptap';
import React from 'react';

export default function IndentParagraphToolbarButtons() {
  const editor = useRichTextEditorContext();
  return (
    <>
      <MenuButton
        disabled={!editor?.isEditable || !editor.can().decreaseIndent()}
        IconComponent={FormatIndentDecrease}
        tooltipLabel="Reduser innrykk"
        onClick={() => editor?.chain().focus().decreaseIndent().run()}></MenuButton>
      <MenuButton
        disabled={!editor?.isEditable || !editor.can().increaseIndent()}
        IconComponent={FormatIndentIncrease}
        tooltipLabel="Øk innrykk"
        onClick={() => editor?.chain().focus().increaseIndent().run()}></MenuButton>
    </>
  );
}
